import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('cleopatra', {
  cherry: 'lotus',
  lemon: 'wine_goblet',
  orange: 'hand_mirror',
  bell: 'feather_fan',
  star: 'cleopatra_wild',
  seven: 'golden_asp',
  gem: 'emerald_necklace',
  scatter: 'royal_barge_scatter',
  money: 'queens_treasure',
});

/** Cleopatra's Palace — GENERATED by scaffoldSlot from
 *  content/slots/cleopatra.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const CLEOPATRA_THEME: Theme = {
  id: 'cleopatra',
  name: 'Cleopatra\'s Palace',
  palette: {
    accent: 0x2e78b0,
    secondary: 0xe0a52e,
    warm: 0xffe49a,
    frameFill: 0x14223a,
    bgGradientTop: 0x16294a,
    bgGradientBottom: 0x070c16,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Lotus', glyph: '🪷', tint: 0x4FA0E0, weight: 5, textureAlias: 'cleopatra:cherry',
        winVideoAlias: 'cleopatra:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Goblet', glyph: '🍷', tint: 0xE0A52E, weight: 5, textureAlias: 'cleopatra:lemon',
        winVideoAlias: 'cleopatra:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Mirror', glyph: '🪞', tint: 0xE0A52E, weight: 4, textureAlias: 'cleopatra:orange',
        winVideoAlias: 'cleopatra:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Fan', glyph: '🪶', tint: 0xE8E0C8, weight: 3, textureAlias: 'cleopatra:bell',
        winVideoAlias: 'cleopatra:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Cleopatra', glyph: '👸', tint: 0xFFE49A, weight: 2, textureAlias: 'cleopatra:star',
        winVideoAlias: 'cleopatra:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Golden Asp', glyph: '🐍', tint: 0xE0A52E, weight: 2, textureAlias: 'cleopatra:seven',
        winVideoAlias: 'cleopatra:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Necklace', glyph: '💚', tint: 0x3E9E72, weight: 2.5, textureAlias: 'cleopatra:gem',
        winVideoAlias: 'cleopatra:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Royal Barge', glyph: '⛵', tint: 0x2E78B0, weight: 0.5, textureAlias: 'cleopatra:scatter',
        winVideoAlias: 'cleopatra:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Queen\'s Treasure', glyph: '🪙', tint: 0xE0A52E, weight: 1, textureAlias: 'cleopatra:money',
        winVideoAlias: 'cleopatra:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x14223a, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x2e78b0, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xffe49a, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xe0a52e, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x2e78b0, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xffe49a, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xffe49a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x14223a, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xe0a52e, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x2e78b0, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xffe49a, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xffe49a, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'cleopatra:bg', path: 'environment/cleopatra.png' },
      columnBackground: { alias: 'cleopatra:column_bg', path: 'reel/cleopatra_column_bg.png' },
      border: { alias: 'cleopatra:border', path: 'brand/border_egypt.png' },
    },
  },
};
